import React from "react";
import { AppBar, Dialog, Slide, Toolbar } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const WorkerProfileDialog = ({
  visibleWorker,
  handleCloseWorker,
  formData,
  selectedcategories
}) => {
  return (
    <Dialog
      fullScreen
      open={visibleWorker}
      onClose={handleCloseWorker}
      TransitionComponent={Transition}
      style={{ zIndex: 2235 }}
    >
      <AppBar className="position-relative">
        <Toolbar>
          <button
            type="button"
            className="close-modal-button"
            onClick={handleCloseWorker}
          >
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">
            {formData?.first_name} {formData?.last_name}
          </h4>
        </Toolbar>
      </AppBar>
      <div style={{ padding: "25px" }}>
        <div className="row">
          <div className={"col-sm-6"}>
            <label htmlFor="">Profile image</label>
            <div className="form-group">
              <div className="col-sm-2">
                <img
                  src={`${process.env.REACT_APP_FILES_PATH}/userProfiles/${formData.profile_image_name}`}
                  className="w-100 mt-3"
                />
              </div>
            </div>
          </div>
          <div className={"col-sm-6"}>
            <label htmlFor="">ID image</label>
            <div className="col-sm-2">
              <img
                src={`${process.env.REACT_APP_FILES_PATH}/userProfiles/${formData.id_image_name}`}
                className="w-100 mt-3"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className={"col-sm-6"}>
            <label htmlFor="email: ">Email : </label>
            <b>{formData.email}</b>
          </div>
        </div>
        <div className="row">
          <div className={"col-sm-6"}>
            <label htmlFor="phone">Phone : </label>
            <b>{formData.phone}</b>
          </div>
          <div className={"col-sm-6"}>
            <label htmlFor="phone">Address : </label>
            <b>{formData.address}</b>
          </div>
        </div>
        <label htmlFor="profile_description">Profile Description : </label>
        <b>{formData.profile_description}</b>
        <div className="row" style={{ marginTop: 20 }}>
          <div className={"col-sm-12"}>
            {selectedcategories?.map((category, index) => (
              <p key={index}>{category.name}</p>
            ))}
          </div>
        </div>
        <div className="row">
          {selectedcategories?.map((category, index) => (
            !formData.attachments?.some((x) => x.category_id == category.id) ? (
              <div style={{ width: "auto" }} key={index}></div>
            ) : (
              <div
                key={index}
                className={"col-sm-4"}
                style={{ position: "relative" }}
              >
                <label htmlFor={category.name}>
                  License for {category.name}
                </label>
                <div id={category.name}>
                  <object
                    width="100%"
                    height="200"
                    data={
                      formData.attachments.find((x) => x.category_id == category.id)?.path ??
                      `${process.env.REACT_APP_FILES_PATH}/userFiles/${
                        formData.attachments.find((x) => x.category?.id == category.id)?.attachment_name
                      }`
                    }
                    type="application/pdf"
                  ></object>
                </div>
              </div>
            )
          ))}
        </div>
        {formData.posts?.map((post, index) => (
          <div className="row" style={{ padding: "20px" }} key={index}>
            <div className="profile-post-item">
              <div style={{ display: "flex", justifyContent: "space-between" }}></div>
              <div className="profile-post-images">
                {post.attachments?.map((attachement, i) => (
                  <div style={{ maxHeight: "300px", position: "relative" }} key={i}>
                    {attachement.image_name.includes("mp4") ? (
                      <video controls>
                        <source
                          src={`${process.env.REACT_APP_FILES_PATH}/posts/${attachement.image_name}`}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        style={{ height: "100%" }}
                        src={`${process.env.REACT_APP_FILES_PATH}/posts/${attachement.image_name}`}
                      />
                    )}
                  </div>
                ))}
              </div>
              <div className="profile-post-desc">
                <p>{post.description}</p>
              </div>
            </div>
          </div>
        ))}
        <div className="row mt-5">
          <div className={"col-sm-6"}>
            <div className="form-group" style={{ padding: "20px" }}>
              <input
                className="form-control-checkbox"
                id="active"
                type="checkbox"
                checked={formData.active == 1}
                disabled
              />
              <label style={{ paddingLeft: 10 }} htmlFor="active">
                Active
              </label>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default WorkerProfileDialog; 